import Vue from "vue";
import Dialog from "../components/Dialog.vue";
/**
 * Usage:
 *  const answer = await prompt("title", "inhoud", "ok", "cancel");
 *
 * @param {String} title
 * @param {String} body
 * @param {String} label
 * @param {String} cancel
 * @param {Boolean} noCancel
 */
export function confirm(
  title,
  body,
  label,
  cancel = "Annuleer",
  noCancel = false
) {
  return new Promise((resolve, reject) => {
    const dialog = new Vue({
      methods: {
        closeHandler(fn, arg) {
          return function() {
            fn(arg);
            dialog.$destroy();
            dialog.$el.remove();
          };
        }
      },
      render(h) {
        return h(Dialog, {
          props: {
            title,
            body,
            answers: [
              { answer: "cancel", label: cancel },
              { answer: "ok", label }
            ],
            primary: "ok",
            noCancel
          },
          on: {
            cancel: this.closeHandler(reject, new Error(cancel)),
            answer: this.closeHandler(resolve, label)
          }
        });
      }
    }).$mount();
    document.body.appendChild(dialog.$el);
  });
}

export default { confirm };
